import * as Yup from 'yup';
import { validUSState } from 'common/helpers/yup-helpers';

Yup.addMethod(Yup.mixed, 'validUSState', validUSState);

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name or Company is required!'),
  relationship: Yup.string().required('Relationship is required'),
  address: Yup.string().ensure().required('Address is required!'),
  address2: Yup.string().nullable(),
  city: Yup.string().ensure().required('City is required!'),
  state: Yup.string().ensure().validUSState('interested-party.state'),
  zip: Yup.string().ensure().required('Zip is required!')
});
